import React, { useContext } from 'react';

import { Typography, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ApplicationUIContext, Table } from '@yuhuinc/ui-library';

import { getTranslatedString } from 'helpers/i18n';

import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Title } = Typography;

const COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.name'
    ),
    dataIndex: 'cotenant_name',
    key: 'name',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.flagType'
    ),
    dataIndex: 'human_flag_type',
    key: 'flagType',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.description'
    ),
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.flaggedContent'
    ),
    dataIndex: 'flagged_content',
    key: 'flaggedContent',
  },
  {
    key: 'actions',
    render() {
      return <Button type="link" icon={<EditOutlined />} />;
    },
  },
];

const FLAGGED_PRIOR_RESIDENTS_COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.name'
    ),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.property'
    ),
    dataIndex: 'property',
    key: 'property',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.unit'
    ),
    dataIndex: 'unit',
    key: 'unit',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.leaseEndDate'
    ),
    dataIndex: 'leaseEndDate',
    key: 'leaseEndDate',
  },
];

const Flags = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.flags'
        )}
      </Title>
      <Table
        dataSource={application.flags.filter((flag) => flag.flag_source === 'cotenant')}
        rowKey="id"
        columns={COLUMNS}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        pagination={false}
        // WIP: expandable rows will be implemented for other flag types 👇
        rowExpandable={(record) => record.flaggedPriorResidents}
        expandedRowRender={(record) => (
          <Table
            dataSource={record.flaggedPriorResidents}
            columns={FLAGGED_PRIOR_RESIDENTS_COLUMNS}
            hideActionAndSearch
            size={isMobile ? 'middle' : 'small'}
            scroll={{
              x: isMobile,
            }}
            pagination={false}
          />
        )}
      />
    </>
  );
};

export default Flags;
